import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { cn } from "@/shared/lib";
import { SeverityDot } from "@/shared/ui/severity-dot";

import { FindingView } from "../../findings/FindingView";
import type { Finding } from "../../model/Finding";

const LABEL = msg({ id: "analysis.main.label", message: "The main thing this match" });
const CLEAN_TITLE = msg({ id: "analysis.main.clean_title", message: "No serious mistakes" });
const CLEAN_TEXT = msg({
  id: "analysis.main.clean_text",
  message: "Below: what went well and the match numbers by section.",
});

type MainLessonProps = {
  // Самая важная ошибка матча (`selectFixFirst`); нет — серьёзных ошибок не нашли.
  finding: Finding | undefined;
};

// «Главное в этом матче»: одна ошибка крупно — что случилось, почему и как исправить.
// Ошибок выше порога важности нет — спокойная плашка вместо выдуманной проблемы.
export const MainLesson = ({ finding }: MainLessonProps) => {
  const { _ } = useLingui();
  if (finding === undefined) {
    return (
      <section
        aria-labelledby="analysis-main"
        data-main="clean"
        className="flex items-center gap-3 rounded-[14px] border border-good/40 bg-good/10 px-5 py-4"
      >
        <SeverityDot severity="good" className="size-[30px] text-lg" />
        <div className="flex flex-col">
          <h2 id="analysis-main" className="text-lg font-semibold text-foreground">
            {_(CLEAN_TITLE)}
          </h2>
          <p className="text-sm text-muted">{_(CLEAN_TEXT)}</p>
        </div>
      </section>
    );
  }
  return (
    <section
      aria-labelledby="analysis-main"
      data-main={finding.code}
      className={cn(
        "flex flex-col gap-4 rounded-[14px] border px-5 py-5",
        finding.severity === "bad" ? "border-bad/40 bg-bad/10" : "border-warn/40 bg-warn/10",
      )}
    >
      <h2
        id="analysis-main"
        className={cn(
          "text-xs font-semibold tracking-[0.08em] uppercase",
          finding.severity === "bad" ? "text-bad" : "text-warn",
        )}
      >
        {_(LABEL)}
      </h2>
      <FindingView finding={finding} variant="lead" />
    </section>
  );
};
